import styles from "./Section5Quote.module.scss";

export const Section5Quote = function () {
  return (
    <section id="quote" className={`${styles.section5QuoteWrapper} cc--component-container`}>
      <div className={styles.section5QuoteContainer}>
        <div className={styles.section5QuoteContent}>
          <p>
            “This course strengthened my approach to become a more reflective practitioner who employs the latest
            evidence-based practices in order to serve diverse learners. It provided much-needed pause and reflection as
            an integral part of my professional development. I refined my tools as an experienced educator, added new
            tools to my repertoire as a practitioner, and connected with professionals working in similar fields. We
            spent countless hours giving each other feedback and offering perspectives on materials presented by the
            instructors. The platform was easy to navigate and well-designed, utilizing the latest evidence-based
            principles for teaching and learning in the information age.”
          </p>
          <div>
            <p className={styles.quoteName}>
              Octaviano Merecias-Cuevas <br />
              OHSU Lead Trainer, Center for Diversity and Inclusion
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
